import cx from 'classnames';
import React, { RefObject } from 'react';

import './calendar-plan-showcase.scss';

interface Props {
    children: React.ReactElement[] | React.ReactElement;
    innerRef?: RefObject<HTMLDivElement>;
    mix?: string;
}

export const CalendarPlanShowcase = React.memo(({ children, innerRef, mix }: Props) => (
    <div className={cx('calendar-plan-showcase', mix)} ref={innerRef}>
        {children}
    </div>
));
